import PhotoSwipeLightbox from 'photoswipe/dist/photoswipe-lightbox.esm.js';
import PhotoSwipe from 'photoswipe/dist/photoswipe.esm.js';

const lightbox = new PhotoSwipeLightbox({
    gallery: 'body',
    children: 'a.lightbox',
    pswpModule: PhotoSwipe,
});

lightbox.init();
